(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["packs-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.packsReady) return;
      root.dataset.packsReady = 'true';

      root.querySelectorAll('[data-packs-more]').forEach(function (button) {
        button.addEventListener('click', function () {
          var universe = button.closest('[data-packs-universe]');
          var expanded = button.getAttribute('aria-expanded') === 'true';

          universe.classList.toggle('is-expanded', !expanded);
          button.setAttribute('aria-expanded', String(!expanded));

          if (expanded) {
            universe.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      var links = root.querySelectorAll('[data-packs-nav-link]');

      if (!links.length || !('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            links.forEach(function (link) {
              link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
            });
          });
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );

      root.querySelectorAll('[data-packs-universe]').forEach(function (universe) {
        observer.observe(universe);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-packs-landing]').forEach(init);
    }

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DAY = 24 * 60 * 60 * 1000;

    // Décalage de l'heure de Paris par rapport à UTC, en minutes, à une date donnée.
    function parisOffset(date) {
      var paris = new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
      var utc = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
      return (paris - utc) / 60000;
    }

    // Prochaine fin de bon plan : le jour choisi à 23:59:59, heure de Paris.
    function nextDeadline(endDay) {
      var now = new Date();
      var parisNow = new Date(now.getTime() + parisOffset(now) * 60000);
      var daysToGo = (endDay - parisNow.getUTCDay() + 7) % 7;
      var wall = Date.UTC(parisNow.getUTCFullYear(), parisNow.getUTCMonth(), parisNow.getUTCDate() + daysToGo, 23, 59, 59);
      return new Date(wall - parisOffset(new Date(wall)) * 60000);
    }

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function initCountdown(deal) {
      var box = deal.querySelector('[data-promo-countdown]');
      if (!box) return;

      var label = box.querySelector('[data-promo-countdown-label]');
      var value = box.querySelector('[data-promo-countdown-value]');
      var deadline = nextDeadline(parseInt(deal.dataset.endDay, 10));

      function tick() {
        var left = deadline - new Date();

        if (left <= 0) {
          label.textContent = 'Nouveau bon plan très bientôt';
          value.textContent = '';
          return;
        }

        var days = Math.floor(left / DAY);
        var hours = Math.floor((left % DAY) / 3600000);
        var minutes = Math.floor((left % 3600000) / 60000);
        var seconds = Math.floor((left % 60000) / 1000);

        value.textContent = (days > 0 ? days + 'j ' : '') + pad(hours) + 'h ' + pad(minutes) + 'min ' + pad(seconds) + 's';
        setTimeout(tick, 1000);
      }

      box.hidden = false;
      tick();
    }

    function initList(root) {
      var grid = root.querySelector('[data-promo-grid]');
      if (!grid) return;

      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-promo-item]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-promo-tab]'));
      var sort = root.querySelector('[data-promo-sort]');
      var count = root.querySelector('[data-promo-count]');
      var empty = root.querySelector('[data-promo-empty]');
      var more = root.querySelector('[data-promo-more]');
      var moreLabel = root.querySelector('[data-promo-more-label]');
      var mobile = window.matchMedia('(max-width: 1023px)');

      var state = { tab: '', sort: 'discount', shown: 0 };

      function step() {
        return parseInt(mobile.matches ? root.dataset.stepMobile : root.dataset.step, 10) || 8;
      }

      function matches(item, handles) {
        if (!handles) return true;
        return handles.split('|').some(function (handle) {
          return handle && item.dataset.collections.indexOf('|' + handle + '|') !== -1;
        });
      }

      function compare(a, b) {
        var stock = (b.dataset.available === 'true') - (a.dataset.available === 'true');
        if (stock) return stock;

        var result = 0;
        if (state.sort === 'discount') result = b.dataset.discount - a.dataset.discount;
        if (state.sort === 'price-asc') result = a.dataset.price - b.dataset.price;
        if (state.sort === 'price-desc') result = b.dataset.price - a.dataset.price;

        return result || a.dataset.position - b.dataset.position;
      }

      function render() {
        var visible = items.filter(function (item) {
          return matches(item, state.tab);
        });

        visible.sort(compare);
        items.forEach(function (item) {
          item.classList.add('is-hidden');
        });

        visible.forEach(function (item, index) {
          grid.appendChild(item);
          if (index < state.shown) item.classList.remove('is-hidden');
        });

        var total = visible.length;
        var remaining = Math.max(total - state.shown, 0);
        var next = Math.min(step(), remaining);

        count.textContent = total + (total > 1 ? ' produits en promotion' : ' produit en promotion');
        empty.hidden = total > 0;
        more.hidden = remaining === 0;
        moreLabel.textContent = next > 1 ? 'Voir ' + next + ' promotions de plus' : 'Voir la dernière promotion';
      }

      // Masque les onglets sans aucune promo.
      tabs.forEach(function (tab) {
        if (!tab.dataset.promoTab) return;
        var hasItems = items.some(function (item) {
          return matches(item, tab.dataset.promoTab);
        });
        if (!hasItems) tab.hidden = true;
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (other) {
            other.classList.toggle('is-active', other === tab);
            other.setAttribute('aria-selected', String(other === tab));
          });
          state.tab = tab.dataset.promoTab;
          state.shown = step();
          render();
        });
      });

      sort.addEventListener('change', function () {
        state.sort = sort.value;
        render();
      });

      more.addEventListener('click', function () {
        state.shown += step();
        render();
      });

      state.shown = step();
      render();
    }

    function init(root) {
      if (root.dataset.promoReady) return;
      root.dataset.promoReady = 'true';

      var deal = root.querySelector('[data-promo-deal]');
      if (deal) initCountdown(deal);

      initList(root);
    }

    function initAll() {
      document.querySelectorAll('[data-promo-landing]').forEach(init);
    }

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
